import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput } from '@ionic/react';

import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { UpdateRoomBookedModal } from './Modal_UpdateBookedRoom';
import { EnterCheckInInfoModal } from './Modal_EnterCheckInInfo';

import '../css/hotelCss.css';
import { UpdateCheckInDateModal } from './Modal_Update_checkInDate';
import { UpdateCheckOutDateModal } from './Modal_Update_checkOutDate';
import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

export function CheckedOutRoomDetailsModal_multiple(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    
    let [constant_roomID, setConstant_roomID] = useState(props.data.roomID);
    let [constant_roomType, setConstant_roomType] = useState(null);
    let [constant_roomDescription, setConstant_roomDescription] = useState(null);
    let [constant_roomPartNum, setConstant_roomPartNum] = useState(null);
    let [constant_roomPhoneNumber, setConstant_roomPhoneNumber] = useState(null);
    let [constant_address, setConstant_address] = useState(null);
    let [constant_city, setConstant_city] = useState(null);
    let [constant_country, setConstant_] = useState(null);
    let [constant_roomSalePrice, setConstant_roomSalePrice] = useState(null);
    let [constant_roomPic1, setConstant_roomPic1] = useState(null);
    let [constant_roomPic2, setConstant_roomPic2] = useState(null);
    let [constant_roomPic3, setConstant_roomPic3] = useState(null);
    let [constant_roomPic4, setConstant_roomPic4] = useState(null);
    let [constant_attachment, setConstant_attachment] = useState(null);
    let [constant_roomGuestFirstName, setConstant_roomGuestFirstName] = useState(null);
    let [constant_roomGuestLastName, setConstant_roomGuestLastName] = useState(null);
    let [constant_roomGuestPhoneNumber, setConstant_roomGuestPhoneNumber] = useState(null);
    let [constant_roomGuestEmail, setConstant_roomGuestEmail] = useState(null);
    let [constant_roomGuestPaymentType, setConstant_roomGuestPaymentType] = useState(null);
    let [constant_roomGuestPrice, setConstant_roomGuestPrice] = useState(null);
    let [constant_roomGuestCheckInDateBooked, setConstant_roomGuestCheckInDateBooked] = useState(null);
    let [constant_roomGuestCheckOutDateBooked, setConstant_roomGuestCheckOutDateBooked] = useState(null);
    let [constant_roomGuestCheckInDateActual, setConstant_roomGuestCheckInDateActual] = useState(null);
    let [constant_merchantInvoiceID, setConstant_merchantInvoiceID] = useState(null);
    let [constant_customerInvoiceID, setConstant_customerInvoiceID] = useState(null);
    let [constant_invoiceSentStatus, setConstant_invoiceSentStatus] = useState(null);
    let [constant_transactionID, setConstant_transactionID] = useState(null);
    let [constant_transactionTotalAmount, setConstant_transactionTotalAmount] = useState(null);
    let [constant_transactionStatus, setConstant_transactionStatus] = useState(null);
    let [constant_roomGuestInvoiceAttachment, setConstant_roomGuestInvoiceAttachment] = useState(null);
    let [constant_numOfNights, setConstant_numOfNights] = useState(null);

    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [roomID, setRoomID] = useState(null);
    let [roomID_current, setRoomID_current] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [bookedFirstName, setBookedFirstName] = useState(null);
    let [bookedLastName, setBookedLastName] = useState(null);
    let [bookedPhoneNumber, setBookedPhoneNumber] = useState(null);
    let [bookedEmail, setBookedEmail] = useState(null);

    let [bookedStartDate, setBookedStartDate] = useState(null);
    let [bookedStartDate_multiple, setBookedStartDate_multiple] = useState([]);

    let [bookedEndDate, setBookedEndDate] = useState(null);
    let [bookedEndDate_multiple, setBookedEndDate_multiple] = useState([]);

    let [numOfNights, setDateRangeNumberOfNights] = useState(null);
    let [numOfNights_multiple, setDateRangeNumberOfNights_multiple] = useState([]);

    let [guestPayAmount, setGuestPayAmount] = useState(null);
    let [guestPayAmountTotal, setGuestPayAmountTotal] = useState(null);
    let [guestPayAmount_multiple, setGuestPayAmount_multiple] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    let [showPasswordModal_refund, setShowPasswordModal_refund] = useState(false);

    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);

    let [checkInModal, setCheckInModal] = useState(false);

    //let [enteredPassword, setEnterPassword] = useState(null);

    let [viewInventoryBookedRoomDetailData, setViewInventoryBookedRoomDetailData] = useState([]);
    let [bookingStatus, setBookingStatus] = useState('bookToCheckIn');

    let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showUpdateBookedRoomModal, setShowUpdateBookedRoomModal] = useState(false);
    let [showUpdateCheckInDateModal, setShowUpdateCheckInDateModal] = useState(false);
    let [showUpdateCheckOutDateModal, setShowUpdateCheckOutDateModal] = useState(false);

    let [roomGuestInvoiceAttachment, setRoomGuestInvoiceAttachment] = useState(null);

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [displaySetButton, setDisplaySetButton] = useState('inline-block');
    let [displayResetButton, setDisplayResetButton] = useState('none');
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);

    let [disableRefundButton, setDisableRefundButton] = useState(false);

    let [displaySetButton_refund, setDisplaySetButton_refund] = useState('inline-block');
    let [displayResetButton_refund, setDisplayResetButton_refund] = useState('none');
    let [disableSetButton_refund, setDisableSetButton_refund] = useState(false);
    let [disableResetButton_refund, setDisableResetButton_refund] = useState(false);

    let [checkInInvoice_send, setCheckInInvoice_send] = useState(null);
    let [checkInInvoice_sent, setCheckInInvoice_sent] = useState(null);
    let [checkInInvoice_confirmPaid, setCheckInInvoice_confirmPaid] = useState(null);
        let [checkInInvoice_confirmPaid_non_member, setCheckInInvoice_confirmPaid_non_member] = useState(null);
    let [checkInInvoice_paid, setCheckInInvoice_paid] = useState(null);

    let [partialPaymentStatus, setPartialPaymentStatus] = useState(false);

    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(() => {

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });

          return noImageFile;
        
    });

    let enterPayRef = useRef(0);
    let enterRefundRef = useRef(0);


    function handleEnterAttachement() {  

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });
        
        setCheckInAttachment_ID(noImageFile);

        alert("No Attachment Option checked");
    }

    useEffect(() => {


            /*
            let formData = new FormData();
            formData.append('Tracker', '74002I_Paid_In_Full_CheckOut_multiple');
            formData.append('user', acctID);
            //formData.append('xCheckInRoomID', checkInRoomID);
            formData.append('xCheckInRoomID_multiple', props.data.roomID);
            //formData.append('xBookingID', props.data.bookingID);
            formData.append('xInvoiceID', props.data.merchantInvoiceID);

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002I_Paid_In_Full_CheckOut_multiple',
                    user: acctID,
                    xCheckInRoomID_multiple: props.data.roomID,
                    xInvoiceID: props.data.merchantInvoiceID,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
                
                let payAmountTotal = 0.00;
                let numOfNights_multiple = [];
                let checkInDateBooked_multiple = [];
                let checkOutDateBooked_multiple = [];
                let payAmount_multiple = [];

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    let date1 = new Date(cols[20]);
                    let date2 = new Date(cols[21]);
                    let timeDiff;

                    if(date2.getDate() < date1.getDate())
                    {
                        if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                        {
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                            }
                        }
                        else if(date2.getMonth() == 1)
                        {
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                            }
                        }
                        else
                        {
                            //alert('In Get Dates');
                            //alert(date1.getDate());
                            //alert(date2.getDate());
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                            }
                        }

                    }
                    else
                    {
                        timeDiff = Math.abs(date2.getDate() - date1.getDate());
                    }

                    numOfNights_multiple.push(timeDiff);

                    setBookedStartDate(date1);
                    checkInDateBooked_multiple.push(date1.toISOString().substr(0, 10));

                    setBookedEndDate(date2);
                    checkOutDateBooked_multiple.push(date2.toISOString().substr(0, 10));

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                        timeDiff = 1;
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);

                        payAmount_multiple.push(cols[19]);
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        //setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
                        payAmountTotal = parseFloat(Number(payAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);

                        payAmount_multiple.push(cols[19]);
                    }

                    if(cols[25] == 'N')
                    {
                        
                        if(cols[29] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[28]*1).toFixed(2)) == 0.00)
                        {
                            setBookingStatus('bookToCheckIn_depositPaid');
                            
                            setCheckInInvoice_send('none');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_confirmPaid_non_member('none');
                            setCheckInInvoice_paid('inline-block');
                        }
                        else if(cols[29] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[28]*1).toFixed(2)) > 0.00)
                        {
                            setPartialPaymentStatus(true);
                            setBookingStatus('bookToCheckIn_depositPaid');

                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
                        else
                        {
                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
        
                    }
                    
                    else if(cols[25] == 'PR')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('inline-block');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'R_PC')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('inline-block');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'C')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_confirmPaid_non_member('none');
                        setCheckInInvoice_paid('inline-block');
        
                    }

                    //roomID: cols[0],
                    //roomType: cols[1],
                    //roomDescription: cols[2],
                    //roomPartNum: cols[3],
                    setConstant_roomPhoneNumber(cols[4]);
                    //address: cols[5],
                    //city: cols[6],
                    //country: cols[7],
                    setConstant_roomSalePrice(cols[8]);
                    //roomPic1: cols[9],
                    //roomPic2: cols[10],
                    //roomPic3: cols[11],
                    //roomPic4: cols[12],
                    //attachment: cols[13],
                    setConstant_roomGuestFirstName(cols[14]);
                    setConstant_roomGuestLastName(cols[15]);
                    setConstant_roomGuestPhoneNumber(cols[16]);
                    setConstant_roomGuestEmail(cols[17]);
                    setConstant_roomGuestPaymentType(cols[18]);
                    //roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                    //roomGuestCheckInDateBooked: cols[20],
                    //roomGuestCheckOutDateBooked: cols[21],
                    //roomGuestCheckInDateActual: cols[22],
                    setConstant_merchantInvoiceID(cols[23]);
                    setConstant_customerInvoiceID(cols[24]);
                    //setConstant_invoiceSentStatus: cols[25],
                    setConstant_transactionID(cols[27]);
                    setConstant_transactionTotalAmount(parseFloat(cols[28]*1).toFixed(2));
                    //transactionStatus: cols[28],
                    //roomGuestInvoiceAttachment: cols[29],
                    //numOfNights: timeDiff,

                    setViewInventoryBookedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                        return prevViewInventoryOccupiedRoomDetailData.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: cols[8],
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachment: cols[13],
                            roomGuestFirstName: cols[14],
                            roomGuestLastName: cols[15],
                            roomGuestPhoneNumber: cols[16],
                            roomGuestEmail: cols[17],
                            roomGuestPaymentType: cols[18],
                            roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                            roomGuestCheckInDateBooked: cols[20],
                            roomGuestCheckOutDateBooked: cols[21],
                            roomGuestCheckInDateActual: cols[22],
                            merchantInvoiceID: cols[23],
                            customerInvoiceID: cols[24],
                            invoiceSentStatus: cols[25],
                            invoiceTotalAmount: cols[26],
                            transactionID: cols[27],
                            transactionTotalAmount: parseFloat(cols[28]*1).toFixed(2),
                            transactionStatus: cols[29],
                            roomGuestInvoiceAttachment: cols[30],
                            numOfNights: timeDiff,
                        })
                    });
                    setRoomSalePrice(parseFloat(cols[19]).toFixed(2));
                    setGuestPayAmountTotal(parseFloat(cols[26]).toFixed(2));
                }    

                //setGuestPayAmountTotal(payAmountTotal);
                setGuestPayAmount_multiple(payAmount_multiple);
                setDateRangeNumberOfNights_multiple(numOfNights_multiple);
                setBookedStartDate_multiple(checkInDateBooked_multiple);
                setBookedEndDate_multiple(checkOutDateBooked_multiple);

            })
    }, []);


    function onSubmitNewDateHandler(e)
    {
        setViewInventoryBookedRoomDetailData([]);


        /*
        let formData = new FormData();
        formData.append('user', acctID);
        if(roomID_current == null)
        {
            formData.append('xCheckInRoomID', props.data.roomID);
        }
        else
        {
            formData.append('xCheckInRoomID', roomID_current);
        }
        formData.append('xBookingID', props.data.bookingID);
        */


        let checkInRoomID = '';
        let Tracker = '';
        let startDateRange = '';
        let endDateRange = '';
        let checkInNumberOfNights = '';

        if(roomID_current == null)
        {
            checkInRoomID = props.data.roomID;
        }
        else
        {
            checkInRoomID = props.data.roomID_current;
        }


        if(bookingStatus == "bookToCheckIn")
        {
            if(e[0] == 'IN')
            {
                let date1 = e[1];
                let date2 = new Date(new Date(bookedEndDate));
                let timeDiff;

                if(date2.getDate() < date1.getDate())
                {
                    if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }
                    else if(date2.getMonth() == 1)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                        }
                    }
                    else
                    {
                        //alert('In Get Dates');
                        //alert(date1.getDate());
                        //alert(date2.getDate());
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }

                }
                else
                {
                    timeDiff = Math.abs(date2.getDate() - date1.getDate());
                }
                
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_IN_unpaid');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_IN_unpaid';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
            }
            else if(e[0] == 'OUT')
            {
                let date1 = new Date(new Date(bookedStartDate));
                let date2 = e[1];
                let timeDiff;

                if(date2.getDate() < date1.getDate())
                {
                    if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }
                    else if(date2.getMonth() == 1)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                        }
                    }
                    else
                    {
                        //alert('In Get Dates');
                        //alert(date1.getDate());
                        //alert(date2.getDate());
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }

                }
                else
                {
                    timeDiff = Math.abs(date2.getDate() - date1.getDate());
                }
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_OUT_unpaid');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff); 
                */

                Tracker = '74113_U_OUT_unpaid';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
            }
        }
        else if(bookingStatus == "bookToCheckIn_depositPaid")
        {
            if(e[0] == 'IN')
            {
                let date1 = e[1];
                let date2 = new Date(new Date(bookedEndDate));
                let timeDiff;

                if(date2.getDate() < date1.getDate())
                {
                    if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }
                    else if(date2.getMonth() == 1)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                        }
                    }
                    else
                    {
                        //alert('In Get Dates');
                        //alert(date1.getDate());
                        //alert(date2.getDate());
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }

                }
                else
                {
                    timeDiff = Math.abs(date2.getDate() - date1.getDate());
                }
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_IN');
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_IN';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
            }
            else if(e[0] == 'OUT')
            {
                let date1 = new Date(new Date(bookedStartDate));
                let date2 = e[1];
                let timeDiff;

                if(date2.getDate() < date1.getDate())
                {
                    if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }
                    else if(date2.getMonth() == 1)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                        }
                    }
                    else
                    {
                        //alert('In Get Dates');
                        //alert(date1.getDate());
                        //alert(date2.getDate());
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }

                }
                else
                {
                    timeDiff = Math.abs(date2.getDate() - date1.getDate());
                }
        
                setBookedStartDate(date1);
                setBookedEndDate(date2);
                setDateRangeNumberOfNights(timeDiff);

                /*
                formData.append('Tracker', '74113_U_OUT'); 
                formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
                formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
                formData.append('xCheckInNumberOfNights', timeDiff);
                */

                Tracker = '74113_U_OUT';
                startDateRange = date1.toISOString().substr(0, 10);
                endDateRange = date2.toISOString().substr(0, 10);
                checkInNumberOfNights = timeDiff;
            }
        }


        /*
        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xCheckInRoomID: checkInRoomID,
                xBookingID: props.data.bookingID,
                xStartDateRange: startDateRange,
                xEndDateRange: endDateRange,
                xCheckInNumberOfNights: checkInNumberOfNights,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let rows = data.toString().split('~~~');
                
                let setGuestPayAmountTotal = 0.00;
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    let date1 = new Date(cols[20]);
                    let date2 = new Date(cols[21]);
                    let timeDiff;

                    if(date2.getDate() < date1.getDate())
                    {
                        if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                        {
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                            }
                        }
                        else if(date2.getMonth() == 1)
                        {
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                            }
                        }
                        else
                        {
                            //alert('In Get Dates');
                            //alert(date1.getDate());
                            //alert(date2.getDate());
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                            }
                        }

                    }
                    else
                    {
                        timeDiff = Math.abs(date2.getDate() - date1.getDate());
                    }

                    setBookedStartDate(date1);
                    setBookedEndDate(date2);

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        //setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                        timeDiff = 1;
                        setGuestPayAmountTotal = parseFloat(Number(setGuestPayAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        //setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
                        setGuestPayAmountTotal = parseFloat(Number(setGuestPayAmountTotal) + Number(cols[19]*timeDiff)).toFixed(2);
                    }

                    if(cols[25] == 'N')
                    {
                        
                        if(cols[28] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) == 0.00)
                        {
                            setBookingStatus('bookToCheckIn_depositPaid');
                            
                            setCheckInInvoice_send('none');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_confirmPaid_non_member('none');
                            setCheckInInvoice_paid('inline-block');
                        }
                        else if(cols[28] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[27]*1).toFixed(2)) > 0.00)
                        {
                            setPartialPaymentStatus(true);
                            setBookingStatus('bookToCheckIn_depositPaid');

                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
                        else
                        {
                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
        
                    }
                    
                    else if(cols[25] == 'PR')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('inline-block');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'R_PC')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('inline-block');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'C')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_confirmPaid_non_member('none');
                        setCheckInInvoice_paid('inline-block');
        
                    }

                    setViewInventoryBookedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                        return prevViewInventoryOccupiedRoomDetailData.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: cols[8],
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachment: cols[13],
                            roomGuestFirstName: cols[14],
                            roomGuestLastName: cols[15],
                            roomGuestPhoneNumber: cols[16],
                            roomGuestEmail: cols[17],
                            roomGuestPaymentType: cols[18],
                            roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                            roomGuestCheckInDateBooked: cols[20],
                            roomGuestCheckOutDateBooked: cols[21],
                            roomGuestCheckInDateActual: cols[22],
                            merchantInvoiceID: cols[23],
                            customerInvoiceID: cols[24],
                            invoiceSentStatus: cols[25],
                            invoiceTotalAmount: cols[26],
                            transactionID: cols[27],
                            transactionTotalAmount: parseFloat(cols[28]*1).toFixed(2),
                            transactionStatus: cols[29],
                            roomGuestInvoiceAttachment: cols[30],
                            numOfNights: timeDiff,
                        })
                    });
                    setRoomSalePrice(parseFloat(cols[19]).toFixed(2));
                    setGuestPayAmountTotal(parseFloat(cols[26]).toFixed(2));
                }    

                setGuestPayAmountTotal(setGuestPayAmountTotal);
            
            alert('Booking Date Has been updated to '+e[1]);

            props.closeModal();
        })
        .catch(error => {
            console.error(error);
        })

    }

    function prepareInvoice_thenConfirmPay_nonMember(event)
    {

        setDisablePayButton(true);

        //if(partialPaymentStatus == true)
        //{
            /*
            let formData = new FormData();
            formData.append('Tracker', '74108_B');
            formData.append('user', acctID);
            formData.append('xCustMobileNumber', event[3]);
            formData.append('xInvoiceID', event[1]);
            formData.append('xCustomerInvoiceID', event[2]);
            formData.append('xImmediateDestination', acctID);
            formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


            const requestOptions = {
                //enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                body: formData
            }
            */


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74108_B',
                    user: acctID,
                    xCustMobileNumber: event[3],
                    xInvoiceID: event[1],
                    xCustomerInvoiceID: event[2],
                    xImmediateDestination: acctID,
                    xCheckInCashAmount: parseFloat(event[5]).toFixed(2),
                    sessionID: sessionID,
    
                }),
            }

            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(data => {

                confirmPayment_non_member([data, event[1], event[2], event[3], event[4], event[6]]);

            })
            .catch(error => {
                console.error(error);
            })

       // }
        //else
        /*{
           // alert(event);
            //alert(props.data.roomID);
            //alert(checkInAttachment_ID);
           // alert(parseFloat(event[12]).toFixed(2));
           // //alert(guestPayAmount_multiple);
           // alert(guestPayAmount_multiple);

            let formData0 = new FormData();
            formData0.append('Tracker', '74706_deposit_multiple');
            formData0.append('user', acctID);
            formData0.append('xCheckInRoomID', event[6]);
            formData0.append('xCheckInRoomID_multiple', props.data.roomID);
            formData0.append('xCheckInFirstName', event[7]);
            formData0.append('xCheckInLastName', event[8]);
            formData0.append('xCheckInMobileNumber', event[9]);
            formData0.append('xCheckInEmail', event[10]);
            //formData0.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
            //formData0.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
            formData0.append('xImageFile', checkInAttachment_ID);
            formData0.append('xCheckInNonMemberPaymentType', event[11]);
            formData0.append('xCheckInNonMemberPaymentAmount', parseFloat(event[12]).toFixed(2));
            formData0.append('xCheckInNonMemberPaymentAmount_multiple', guestPayAmount_multiple);
            formData0.append('xCheckInDateBooked', bookedStartDate.toISOString().substr(0, 10));
            formData0.append('xCheckInDateBooked_multiple', bookedStartDate_multiple);
            formData0.append('xCheckOutDateBooked', bookedEndDate.toISOString().substr(0, 10));
            formData0.append('xCheckOutDateBooked_multiple', bookedEndDate_multiple);
            formData0.append('xCheckInNumberOfNights', numOfNights);
            formData0.append('xCheckInNumberOfNights_multiple', numOfNights_multiple);
            formData0.append('xBookingID', props.data.bookingID);
    
            const requestOptions0 = {
                //enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                body: formData0
            }
    
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                            let cols = data0.toString().split('|');
    
                            let formData = new FormData();
                            formData.append('Tracker', '74108_B');
                            formData.append('user', acctID);
                            formData.append('xCustMobileNumber', event[3]);
                            //formData.append('xInvoiceID', event[1]);
                            formData.append('xInvoiceID', cols[0]);
                            //formData.append('xCustomerInvoiceID', event[2]);
                            formData.append('xCustomerInvoiceID', cols[1]);
                            formData.append('xImmediateDestination', acctID);
                            formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));
    
    
                            const requestOptions = {
                                //enctype: 'multipart/form-data',
                                method:'POST',
                                credentials: 'include',
                                body: formData
                            }
    
                            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
                            .then(res => res.text())
                            .then(data => {
    
                                confirmPayment_non_member([data, event[1], cols[1], event[3], event[4], event[6]]);
    
                            })
                            .catch(error => {
                                console.error(error);
                            })
    
                        })
        }*/

    }

    function confirmPayment_non_member(event)
    {

        let tracker = event[4];
        let customerInvoiceID = event[2];
        let transactionID = event[0];
        let customerPhoneNumber = event[3];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);
        formData.append('xBookingID', props.data.bookingID);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xCheckInRoomID: event[5],
                xBookingID: props.data.bookingID,
                sessionID: sessionID,

            }),
        }


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            if (data == 'confirmed')
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Payment Confirmed');
            }
            else if(data == 'confirmed_partial')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('inline-block');
                setCheckInInvoice_paid('none');

                alert('Client Partial Payment Confirmed');

            }
            else if (data == 'confirmed_refund')
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Full refund Confirmed');
            }
            else if(data == 'confirmed_partial_refund')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('inline-block');
                setCheckInInvoice_paid('none');

                alert('Client Partial Refund Confirmed');

            }
            else
            {
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('none');

                alert('Error confirming payment');
            }

            props.closeModal();
        })
    }

    function checkInModalHandler(event)
    {
        setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
        setBookedFirstName(event[3]);
        setBookedLastName(event[4]);
        setBookedPhoneNumber(event[5]);
        setBookedEmail(event[6]);

        setBookedStartDate(event[7]);
        setBookedEndDate(event[8]);

        setCheckInModal(event[0]);
    }
    function handleUpdate_checkInDate(event)
    {

        setBookedStartDate(event[1]);
        setBookedEndDate(event[2]);
        setRoomID_current(event[3]);
        setShowUpdateCheckInDateModal(event[0]);
    }
    function handleUpdate_checkOutDate(event)
    {

        setBookedStartDate(event[1]);
        setBookedEndDate(event[2]);
        setRoomID_current(event[3]);
        setShowUpdateCheckOutDateModal(event[0]);
    }

    function refund(event)
    {
        setDisableRefundButton(true);

        /*
        let formData = new FormData();
        formData.append('Tracker', '74108_B_refund');
        formData.append('user', acctID);
        formData.append('xCustMobileNumber', event[3]);
        formData.append('xInvoiceID', event[1]);
        formData.append('xCustomerInvoiceID', event[2]);
        formData.append('xImmediateDestination', acctID);
        formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_refund',
                user: acctID,
                xCustMobileNumber: event[3],
                xInvoiceID: event[1],
                xCustomerInvoiceID: event[2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[5]).toFixed(2),
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            confirmPayment_non_member([data, event[1], event[2], event[3], event[4], event[6]]);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function deleteBooking(enteredPassword)
    {
        //alert('In Delete Booking');
        //alert(props.data.roomID);
        //alert(props.data.bookingID);
        //alert(enteredPassword);

        /*
        let formData = new FormData();
        formData.append('Tracker', 74193);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', props.data.roomID);
        formData.append('xBookingID', props.data.bookingID);
        formData.append('xEnterAdminPassword', enteredPassword);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74193',
                user: acctID,
                xInventoryRoomID: props.data.roomID,
                xBookingID: props.data.bookingID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

        })

        props.closeModal(false);

    }

    function handleUpdate_room(event)
    {

        setBookedStartDate(event[1]);
        setBookedEmail(event[2]);
        setRoomID_current(event[3]);
        setShowUpdateBookedRoomModal(event[0]);
    }

    function viewInvoiceModalHandler(event) {

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setRoomGuestInvoiceAttachment(event[3]);
        setViewInvoiceModal(event[0]);

    }

    function setDepositHandler()
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        //setRoomSalePrice(props.data.roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton(false);
        setDisplayResetButton('inline-block');

    }

    function resetDepositHandler()
    {
        setDisableResetButton(true);
        setDisplayResetButton('none');
        //setRoomSalePrice(props.data.roomSalePrice);
        enterPayRef.current.value = '';
        setDisableSetButton(false);
        setDisplayResetButton('none');
        setDisplaySetButton('inline-block');
    }

    function setRefundHandler()
    {
        setDisableSetButton_refund(true);
        setDisplaySetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton_refund(false);
        setDisplayResetButton_refund('inline-block');

    }

    function resetRefundHandler()
    {
        setDisableResetButton_refund(true);
        setDisplayResetButton_refund('none');
        //setRoomSalePrice(props.data.roomSalePrice);
        enterRefundRef.current.value = '';
        setDisableSetButton_refund(false);
        setDisplayResetButton_refund('none');
        setDisplaySetButton_refund('inline-block');
    }

    function deletBookingHandler(event)
    {
        setShowPasswordModal(true);

    }
    function onSubmitPasswordHandler_refund(event)
    {
        refund();
    }
    function onSubmitPasswordHandler(event)
    {

        deleteBooking(event);
    }
    function closeModalHandler() {

        props.closeModal();
    }

    function closeModalHandler_checkIn() {

        setRoomSalePrice(null);
        setCheckInModal(false);
        props.closeModal();
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_checkInHeader'>
            <IonGrid class='gridModalTopInfo'>
                        <IonRow>
                            <IonCol> All Rooms </IonCol>
                            <IonCol> Total Invoice</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> {props.data.roomID} </IonCol>
                            <IonCol> {parseFloat(guestPayAmountTotal).toFixed(2)} </IonCol>
                        </IonRow>
            </IonGrid>
        </IonHeader>

        <IonContent className='bookedDetails_gridContent_multiple'>
            <IonSlides pager='true' options={{direction: 'horizontal'}}>
            {viewInventoryBookedRoomDetailData.map((detailData) =>   {
            return (
            <IonSlide>
            <IonGrid class='gridText'>
                <IonRow>
                    <IonCol size='12'>
                        Room ID: {detailData.roomID}
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultHeaders'>
                    <IonCol size='3' class='gridResultColumns'>Category</IonCol>
                    <IonCol size='6' class='gridResultColumns'>Value</IonCol>
                    <IonCol size='3' class='gridResultColumns'>Action</IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'> Invoice ID </IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.merchantInvoiceID}</IonCol>
                    {detailData.merchantInvoiceID == 'booking_non_member' && <IonCol size='3' class='gridResultColumns'> <IonButton class='gridResultColumnButton'> - </IonButton> </IonCol>}
                    {detailData.merchantInvoiceID != 'booking_non_member' && <IonCol size='3' class='gridResultColumns'> <IonButton class='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestInvoiceAttachment])}> View </IonButton> </IonCol>}
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Change Room</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{ 'ID: '+detailData.roomID+
                                                        'Part Number: '+detailData.roomPartNum}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                    {detailData.merchantInvoiceID == 'booking_non_member' && <IonButton > - </IonButton>}
                    {detailData.merchantInvoiceID != 'booking_non_member' && <IonButton onClick={() => handleUpdate_room([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked, detailData.roomID])} class='gridResultColumnButton'> Update </IonButton>}
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Room Images</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomType}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: detailData.roomPic1, 
                        roomPic2: detailData.roomPic2, 
                        roomPic3: detailData.roomPic3, 
                        roomPic4: detailData.roomPic4, 
                        roomID: detailData.roomID, 
                        roomSalePrice: detailData.roomSalePrice
                        }}></ShowRoomPicsModal>
                        <IonButton class='gridResultColumnButton' onClick={() => setRoomPicsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Check-In Date</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestCheckInDateBooked}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton onClick={() => handleUpdate_checkInDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked, detailData.roomID])} class='gridResultColumnButton'> Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Check-Out Date</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestCheckOutDateBooked}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton onClick={() => handleUpdate_checkOutDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked, detailData.roomID])} class='gridResultColumnButton'> Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'># of Nights</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.numOfNights}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Guest Contact</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{ 'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName+
                                                        'Phone Number: '+detailData.roomGuestPhoneNumber+
                                                        'Email: '+detailData.roomGuestEmail}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Guest Room Price</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestPrice}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Guest Payment Type</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestPaymentType}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Room Total</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{parseFloat((detailData.roomGuestPrice * detailData.numOfNights)).toFixed(2)}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton' > - </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
            </IonSlide>
                    )
                }
            )}
            
            </IonSlides>
            </IonContent>

            <IonGrid className='bookedDetails_grid_multiple'>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Amount Paid</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{constant_transactionTotalAmount}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton' > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Balance</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{parseFloat(guestPayAmountTotal - constant_transactionTotalAmount).toFixed(2)}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton' > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='3'>
                        Pay
                    </IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterPayRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{enterPayRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDepositHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDepositHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol class='gridResultColumns' size='3'>
                        <IonButton class='gridResultColumnButton' style={{display: checkInInvoice_sent}} > Pending Payment/View Sent </IonButton>
                        {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton id='gridResultColumnButton' disabled={disablePayButton} style={{display: checkInInvoice_confirmPaid_non_member}} onClick={() => prepareInvoice_thenConfirmPay_nonMember([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_Checked_Out', enterPayRef.current.value, constant_roomID])}> Pay</IonButton>}

                        <p class='gridResultColumnButton' style={{display: checkInInvoice_paid}}> Payment Confirmed </p>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol>
                        <IonButton onClick={() => checkInModalHandler([true, constant_roomID, constant_roomSalePrice, constant_roomGuestFirstName, constant_roomGuestLastName, constant_roomGuestPhoneNumber, constant_roomGuestEmail, constant_roomGuestCheckInDateBooked, constant_roomGuestCheckOutDateBooked])} class='gridResultColumnButton'> Check-In Guest </IonButton>
                    </IonCol>
                    <IonCol>
                        {(constant_merchantInvoiceID == 'booking_non_member' || constant_transactionTotalAmount == 0.00) && <IonButton onClick={() => setShowPasswordModal(true)}> Delete Booking </IonButton>}
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='3'>
                        REFUND
                    </IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton_refund}} type='number' placeholder='Enter %' ref={enterRefundRef}></IonInput>
                        <h4 style={{display: displayResetButton_refund}}>{enterRefundRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_refund}} disabled={disableSetButton_refund} onClick={() => setRefundHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_refund}} disabled={disableResetButton_refund} onClick={() => resetRefundHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol size='3'>
                        {constant_merchantInvoiceID != 'booking_non_member' && <IonButton id='gridResultColumnButton' disabled={disableRefundButton} onClick={() => refund([constant_transactionID, constant_merchantInvoiceID, constant_customerInvoiceID, constant_roomGuestPhoneNumber, '74605_B_bookDeposit_refund', enterRefundRef.current.value, constant_roomID])}> Refund </IonButton>}
                    </IonCol>
                </IonRow>
            </IonGrid>


            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>
            <EnterPasswordModal openModal={ showPasswordModal_refund } closeModal={() => setShowPasswordModal_refund(false)} onSubmitPassword={ onSubmitPasswordHandler_refund }></EnterPasswordModal>

            {checkInModal == true && <EnterCheckInInfoModal openModal={ checkInModal } closeModal={() => closeModalHandler_checkIn()} data={{
                        status: bookingStatus,
                        roomID: roomID, 
                        roomSalePrice: roomSalePrice,
                        bookedFirstName: bookedFirstName, 
                        bookedLastName: bookedLastName,
                        bookedPhoneNumber: bookedPhoneNumber,
                        bookedEmail: bookedEmail,
                        bookedStartDate: bookedStartDate,
                        bookedEndDate: bookedEndDate,
                        bookingID: props.data.bookingID
                        }}></EnterCheckInInfoModal>}

            {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: roomGuestInvoiceAttachment, 
                                        roomID: roomID, 
                                        roomSalePrice: roomSalePrice,
                                        }}></ViewInvoiceModal>}

            {showUpdateBookedRoomModal == true && <UpdateRoomBookedModal openModal={ showUpdateBookedRoomModal } closeModal={() => setShowUpdateBookedRoomModal(false)} startDate={new Date(bookedStartDate).toISOString().substr(0, 10)} endDate={new Date(bookedEndDate).toISOString().substr(0, 10)} currentRoom={roomID_current} bookingID={props.data.bookingID}></UpdateRoomBookedModal>}

            {showUpdateCheckInDateModal == true && <UpdateCheckInDateModal openModal={ showUpdateCheckInDateModal } closeModal={() => setShowUpdateCheckInDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckInDateModal>}

            {showUpdateCheckOutDateModal == true && <UpdateCheckOutDateModal openModal={ showUpdateCheckOutDateModal } closeModal={() => setShowUpdateCheckOutDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckOutDateModal>}

        <IonButton className='button_closeModal_center' onClick={closeModalHandler}> Close </IonButton>

        </IonModal>) : null}
    </React.Fragment>
    )
}